import React, { PureComponent } from 'react';
import { Col } from 'react-bootstrap';

class Error404 extends PureComponent {
	render() {
		return (
			<div className="position-absolute top-0 flex-center bg-primary width-all height-all">
				<Col
					sm={4}
					className="text-center"
				>
					<h1 className="text-center margin-top-0 margin-bottom-30">
						<img
							className="width-80-p width-max-250"
							src="/images/rk-logo-new.png"
							alt="RollKall"
						/>
					</h1>
					<h1>404</h1>
					<h4 className="color-white">{ "Oops! You're lost. "}</h4>
					<p>The page you are looking for was not found.</p>
					<a
						href="/"
						className="btn btn-success margin-top-30"
					>
						Go to home page
					</a>
				</Col>
			</div>
		);
	}
}

export default Error404;
